import React, { useState, forwardRef, useImperativeHandle, useLayoutEffect, createRef } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { AddBox, AddCircle, CheckBox, ColorLens, RemoveCircle, Save, Search } from '@mui/icons-material';

import { LoadingButton } from '@mui/lab';
import { globalstyles } from '../lib/definitions';
import { myTimestampToDate } from '../utils/ui_utils';
import { differenceInMonths, format } from 'date-fns';
import { useEvent } from '../context/eventContext';


export const ManualChooseCategory = forwardRef(({ category_list, moveCow }, ref) => {

    const [open, setOpen] = useState(false);
    const [selcow_list, setCowList] = useState([])
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [cur_category, setCurCategory] = useState(-1)
    const [new_category, setNewCategory] = useState(-1)
    const contentRef = createRef()
    const [c_height, setContentHeight] = useState('70vh')

    const [selectedIndex, setSelectedIndex] = useState([])
    const { selEvent } = useEvent()
    const ev_date = myTimestampToDate(selEvent.event_start)





    useImperativeHandle(ref, () => {
        return {
            onEdit(el, i,sel_i) {
                console.log("IS CURRENT", el)
                setOpen(true);
                setIsNew(false)
                setCowList(el)
                setSelectedIndex(sel_i)
                setCurCategory(i)
                setNewCategory(-1)
                setIsEdited(false)
            }
        }
    })

    useLayoutEffect(() => {
        console.log(contentRef.current)
        //setContentHeight(contentRef.current?.clientHeight - 30)

    })



    const handleClose = () => {
        setOpen(false);
    };


    const handleChangeCategory = (c_id) => {
        setNewCategory(c_id)
        if (c_id !== cur_category) {
            setIsEdited(true)

        } else {
            setIsEdited(false)

        }
    }
    const handleSave = () => {
        console.log("MOOOOOVE", cur_category, new_category)
        moveCow(selcow_list, cur_category, new_category, selectedIndex)
        setOpen(false)

    }
    return (


        <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth={true}>
            <DialogTitle>
                Sposta soggetti ({selcow_list.length}) su altra categoria
            </DialogTitle>
            <DialogContent>
                <Grid container>

                    <Grid flexDirection={"column"} size={5} sx={{ maxHeight: c_height, overflow: 'auto' }}>

                        {selcow_list.map((cow, k) => (

                            <Grid sx={{ ...globalstyles.list_container }} flexDirection={"column"}>
                                <Box sx={globalstyles.sectionHeader}>
                                    Dati soggetto
                                </Box>
                                <Grid container sx={globalstyles.list_row}>
                                    <Grid size={2} sx={globalstyles.input_label}>
                                        matricola:
                                    </Grid>
                                    <Grid size="grow">
                                        {cow.serial}
                                    </Grid>
                                </Grid>
                                <Grid container sx={globalstyles.list_row}>
                                    <Grid size={2} sx={globalstyles.input_label}>
                                        nome:
                                    </Grid>
                                    <Grid size="grow" sx={{ fontWeight: 'bold' }}>
                                        {cow.name}
                                    </Grid>
                                </Grid>
                                <Grid container sx={globalstyles.list_row}>
                                    <Grid size={2} sx={globalstyles.input_label}>
                                        nascita:
                                    </Grid>
                                    <Grid size="grow">
                                        {format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}
                                    </Grid>
                                </Grid>
                                <Grid container sx={globalstyles.list_row}>
                                    <Grid size={2} sx={globalstyles.input_label}>
                                        età:
                                    </Grid>
                                    <Grid size="grow">
                                        {differenceInMonths(ev_date, myTimestampToDate(cow.birthdate))} mesi
                                    </Grid>
                                </Grid>
                                <Grid container sx={globalstyles.list_row}>
                                    <Grid size={2} sx={globalstyles.input_label}>                                        parti:
                                    </Grid>
                                    <Grid size="grow">
                                        {cow.birth}
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid sx={{ ...globalstyles.list_container }}>


                        <Box sx={globalstyles.sectionHeader}>
                            Seleziona categoria
                        </Box>
                        <Grid container sx={globalstyles.listHeader}>
                            <Grid size="grow">
                                nome
                            </Grid>
                            <Grid size={2} sx={{ fontSize: '0.8em' }}>
                                # soggetti
                            </Grid>
                            <Grid size={2}>
                            </Grid>
                        </Grid>
                        <Grid flexDirection={"column-reverse"}>
                            {category_list?.map((c, k) => (
                                <Grid container key={k} sx={{ ...globalstyles.list_row, fontSize: '0.8em' }} spacing={1}>
                                    <Grid size="grow" sx={{ fontWeight: c.id === cur_category ? 'bold' : 'normal' }}>
                                        {c.id === cur_category && <CheckBox />}
                                        <Box sx={{ fontWeight: 'bold' }}>
                                            {c.category_name}
                                        </Box>
                                        <Box>
                                            {c.category_description}

                                        </Box>
                                    </Grid>
                                    <Grid size={2}>
                                        {c.cow_list?.length}
                                    </Grid>
                                    <Grid size={2}>
                                        <Button
                                            onClick={() => handleChangeCategory(c.id)}
                                            color={c.id === cur_category ? 'secondary' : 'primary'}
                                            variant={c.id === new_category ? 'contained' : 'outlined'}
                                            size="small"
                                        >seleziona</Button>
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                {isEdited &&
                    <LoadingButton key={'bs'} disabled={isInvalid} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">Sposta</LoadingButton>
                }
            </DialogActions>
        </Dialog>

    )

})